import React, { useState, useRef, useEffect } from 'react';
import { useNavigate, NavLink } from 'react-router-dom';
import { getProfile, logoutUser } from '../../rtk/thunks/authThunk';
import { useDispatch, useSelector } from 'react-redux';
import './Navbar.css';


// Generic placeholder avatar icon (no real profile photo is stored yet)
const UserAvatarIcon = () => (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="60%" height="60%">
        <circle cx="12" cy="8" r="4" fill="currentColor" />
        <path d="M4 20c0-4.418 3.582-8 8-8s8 3.582 8 8" fill="currentColor" />
    </svg>
);

// A new, self-contained component for the dropdown arrow icon
const DropdownArrowIcon = ({ isOpen }) => (
    <svg
        className={`dropdown-arrow ${isOpen ? 'open' : ''}`} // The 'open' class will trigger the rotation
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        <polyline points="6 9 12 15 18 9"></polyline>
    </svg>
);

const Navbar = ({ userName }) => {
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const dropdownRef = useRef(null);
    const navigate = useNavigate();

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsDropdownOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);


    const { user } = useSelector((state) => state.auth);
    const dispatch = useDispatch();

    const handleLogout = async () => {
        await dispatch(logoutUser());
        navigate('/sign-in');
    };

    useEffect(() => {
        if (!user) {
            dispatch(getProfile());
        }
    }, [dispatch, user]);

    return (
        <nav className="navbar-container">
            <div className="welcome-message">
                Welcome<span className="welcome-user-text"> Back, <strong>{userName || 'User'}</strong></span>
            </div>

            {
                user ? (
                    <div className="navbar-right">
                        <div className="profile-section" ref={dropdownRef}>
                            <button
                                className="profile-button"
                                onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                            >
                                <div className="profile-image-container">
                                    <div className="profile-image profile-avatar-fallback" role="img" aria-label="User profile">
                                        <UserAvatarIcon />
                                    </div>
                                    <span className="online-status-dot"></span>
                                </div>
                                <DropdownArrowIcon isOpen={isDropdownOpen} />
                            </button>

                            {isDropdownOpen && (
                                <ul className="dropdown-menu">
                                    <li className="dropdown-item"><NavLink to="/user-profile">Profile</NavLink></li>
                                    <li className="dropdown-item"><NavLink to="/account-settings">Settings</NavLink></li>
                                    <li className="dropdown-item"><NavLink to="/change-password">Change password</NavLink></li>
                                    <li className="dropdown-divider"></li>
                                    <li className="dropdown-item"><button onClick={handleLogout} style={{ background: 'none', border: 'none', color: 'inherit', cursor: 'pointer' }}>Logout</button></li>
                                </ul>
                            )}
                        </div>
                    </div>
                ) : (
                    <NavLink to="/sign-in" className="auth-link">
                        <i className="fas fa-sign-in-alt"></i>
                        <span>Login</span>
                    </NavLink>
                )
            }
        </nav>
    );
};

export default Navbar;
